import { LOAD_STATES } from "../constants/load_states.js";

export default {
  methods: {
    isLoading(state) {
      return state === LOAD_STATES.LOADING;
    },
    isSuccess(state) {
      return state === LOAD_STATES.SUCCESS;
    },
    isError(state) {
      return state === LOAD_STATES.ERROR;
    }
  }
};
